export enum CantPayOnlineReason {
	PriceTooHigh = "PriceTooHigh",
}
